// TODO: split into separate types for image/audio/video etc.?!
export enum MimeTypeDMS {
  PDF = 'application/pdf',
  WORD = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  WORD_OLD = 'application/msword',
  POWERPOINT = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  POWERPOINT_OLD = 'application/vnd.ms-powerpoint',
  POWERPOINT_POTX = 'application/vnd.openxmlformats-officedocument.presentationml.template',
  POSTSCRIPT = 'application/postscript', // .ai, .eps and .ps
  ILLUSTRATOR = 'application/illustrator', // .ai

  JPEG = 'image/jpeg',
  PNG = 'image/png',
  GIF = 'image/gif',
  WEBP = 'image/webp',
  SVG = 'image/svg+xml',
  EPS = 'image/x-eps',

  MPEG_VIDEO = 'video/mpeg',
  MP4_VIDEO = 'video/mp4',
  OGG_VIDEO = 'video/ogg',
  MOV = 'video/quicktime',
  AVI = 'video/avi',
  WEBM = 'video/webm',
  WMV = 'video/x-ms-wmv',
  FLV = 'video/x-flv',

  MP4_AUDIO = 'audio/mp4',
  MPEG_AUDIO = 'audio/mpeg',
  OGG_AUDIO = 'audio/ogg',
  VORBIS = 'audio/vorbis',
}
